module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/COirwH/tc-custom/9781452153346.jpg?1737760216534",
      "alt": "This image is the cover for the book Ultimate Appetizer Ideabook"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ultimate Appetizer Ideabook\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Master the art of the starter—from popcorn to pot stickers. “[A] great resource for frequent entertainers.” —"), _c('i', [_vm._v("Visit Napa Valley")])]), _c('br'), _c('br'), _vm._v("Ultimate Appetizer Ideabook is a cook’s gold mine. Chock-a-block with updated classics, modern-day favorites, and totally unique recipes for hosts of all skill levels, every single preparation is photographed so party planners can envision their array of treats. The 225 recipes cover everything from dips, spreads, and one-bite nibbles to heartier fare requiring a fork or a spoon as well as a section of little sweets perfect for an all-dessert soiree. Whether hosts want to add snazzy new offerings to their repertoire, establish a set of quick recipes for impromptu gatherings, or just learn to make basic appetizers, this chunky, distinctively packaged little volume makes an exceptional pair with our bestselling Ultimate Bar Book.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kiera Stipovich, Cole Stipovich\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kiera and Cole Stipovich are the founders of Cole + Keira Photography, a wedding and family photography business. Kiera also runs a blog and custom-baking service at SweetKiera.com. They are based in Boston.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0